import React from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import { useAuth } from '../../context/AuthContext';

const Layout = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  // Don't show layout on auth pages and landing page
  const authPages = ['/login', '/register', '/forgot-password', '/reset-password'];
  const isAuthPage = authPages.includes(location.pathname) || location.pathname === '/';
  const isSharedPage = location.pathname.startsWith('/shared/');

  if (isAuthPage || isSharedPage || !isAuthenticated) {
    return children;
  }

  return (
    <div className="min-h-screen bg-paper-white">
      <Header />
      <div className="flex">
        <Sidebar />
        <main className="flex-1 lg:ml-64">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
